const SITE_CONFIGS = {
  hostelandpg: {
    key: "hostelandpg",
    domains: ["hostelandpg.com", "www.hostelandpg.com"],

    // Brand
    brandName: "HostelandPG",

    // Feature controls
    features: {
      listingActions: {
        callBack: true,
        visit: true,
      },
    },

    // Property settings
    propertyTypes: ["HOSTEL", "PG"],
    propertyLabel: "Hostels & PGs",
    listingPath: "/property",

    // SEO settings
    defaultTitle: "Best Hostels & PGs Near You | HostelandPG",
    defaultDescription:
      "Find verified hostels and PG accommodation with food, WiFi, security and affordable rooms.",

    canonicalBase: "https://www.hostelandpg.com",
    logo: "/logo1.png",

    // Hero section
    heroTitle: "Book Stays Manage Properties All in One Platform.",
    heroDescription:
      "Discover verified PGs and hostels, while property owners can manage bookings, residents, expenses, revenue, staff and daily operations from a single dashboard.",

    // Search results
    noResultsTitle: "No Hostels or PGs Found",
    noResultsDescription:
      "Try adjusting your filters or searching another location.",

    // City page SEO
    cityTitle: "Best Hostels & PGs in",
  },

  guestopsy: {
    key: "guestopsy",
    domains: ["guestopsy.com", "www.guestopsy.com"],

    // Brand
    brandName: "GuestOpsy",

    // Feature controls
    features: {
      listingActions: {
        callBack: false,
        visit: false,
      },
    },

    // Property settings
    propertyTypes: ["HOTEL", "HOMESTAY", "RESORT", "MICROSTAY"],
    propertyLabel: "Hotels, Homestays, Resorts",
    listingPath: "/property",

    // SEO settings
    defaultTitle: "Hotels, Homestays & Resorts | GuestOpsy",
    defaultDescription:
      "Discover hotels, homestays, resorts and PGs for comfortable stays and easy booking.",

    canonicalBase: "https://www.guestopsy.com",
    logo: "/logo1.png",

    // Hero section
    heroTitle: "Book Stays Manage Properties All in One Platform.",
    heroDescription:
      "Discover verified hotels, homestays, resorts and PGs, while property owners can manage bookings, residents, expenses, revenue, staff and daily operations from a single dashboard.",

    // Search results
    noResultsTitle: "No Stays Found",
    noResultsDescription:
      "Try changing your filters or searching another destination.",

    // City page SEO
    cityTitle: "Hotels, Homestays & Resorts in",
  },
};

// --------------------------------------------------
// GET CURRENT SITE CONFIGURATION
// --------------------------------------------------

const getCurrentSiteConfig = () => {
  const hostname = window.location.hostname.toLowerCase();

  // Local development / testing
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    const params = new URLSearchParams(window.location.search);
    const site = params.get("site")?.toLowerCase();

    if (site === "guestopsy") {
      return SITE_CONFIGS.guestopsy;
    }

    return SITE_CONFIGS.hostelandpg;
  }

  // Production domain detection
  const matchedSite = Object.values(SITE_CONFIGS).find((site) =>
    site.domains.includes(hostname)
  );

  // Default fallback
  return matchedSite || SITE_CONFIGS.hostelandpg;
};

// --------------------------------------------------
// ACTIVE SITE CONFIG
// --------------------------------------------------

export const SITE_CONFIG = getCurrentSiteConfig();

// --------------------------------------------------
// EXPORT ALL SITE CONFIGURATIONS
// --------------------------------------------------

export default SITE_CONFIGS;